export const environment = {
  production: false,
  loanServiceUrl: 'https://ll-test.internal.sparbankensyd.se/api',
  commonServiceUrl: 'https://ll-test.internal.sparbankensyd.se/service',
  userDoc: 'https://dokument-test.lana.sparbankensyd.se/doc',
  showDebug: true,
  domain: 'll-test.internal.sparbankensyd.se'
}
